// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__f8GOV","col":"styles_col__1HeAE"};